import { Button } from 'components/Button';
import CustomAccordion from 'components/CustomAccordion';
import { Typography } from 'components/Typography';
import React from 'react';
import { useHistory, useParams, useRouteMatch } from 'react-router-dom';
import { IPartner } from 'types/Partner';
import {
  maskCep,
  maskCNPJ,
  maskCpf,
  maskPhone,
  maskResidentialPhone,
} from 'util/masks';

import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import { Grid, Stack } from '@mui/material';

type IPartnerView = {
  data: IPartner | undefined;
};

type IItemPartner = {
  title: string;
  icon?: React.ReactNode;
};

const ItemPartner: React.FC<IItemPartner> = ({ title, children, icon }) => {
  return (
    <Grid item xs={3}>
      <Typography color="GrayText">{title}</Typography>
      <Stack direction="row" alignItems="center" spacing={1} mt={1}>
        <Typography color="InfoText" sx={{ wordBreak: 'break-all' }}>
          {children}
        </Typography>

        {icon}
      </Stack>
    </Grid>
  );
};

export const PartnerData: React.FC<IPartnerView> = ({ data }) => {
  let history = useHistory();
  let { path } = useRouteMatch();
  const { id } = useParams<{ id: string }>();

  const url = path.split('view');

  if (!data) {
    return null;
  }

  const {
    socialReason,
    company,
    cnpj,
    cpf,
    responsible,
    phone,
    mobilePhone,
    address,
    email,
    socialMedias,
  } = data;

  return (
    <CustomAccordion title="">
      <Grid container spacing={2}>
        <ItemPartner title="Razão Social">{socialReason}</ItemPartner>
        <ItemPartner title="Nome Fantasia">{company}</ItemPartner>
        <ItemPartner title="Número do CNPJ">{maskCNPJ(cnpj)}</ItemPartner>
        <ItemPartner title="Número do CPF">{maskCpf(cpf)}</ItemPartner>
        <ItemPartner title="Responsável">{responsible}</ItemPartner>
        <ItemPartner title="Telefone Fixo">
          {maskResidentialPhone(phone)}
        </ItemPartner>
        <ItemPartner
          title="Telefone Celular"
          icon={
            mobilePhone?.isWhatsapp && (
              <WhatsAppIcon fontSize="small" style={{ marginBottom: 2 }} />
            )
          }
        >
          {maskPhone(mobilePhone?.number)}
        </ItemPartner>
        <ItemPartner title="CEP">{maskCep(address?.cep)}</ItemPartner>
        <ItemPartner title="Logradouro">{address?.street}</ItemPartner>
        <ItemPartner title="Número">{address?.number}</ItemPartner>
        <ItemPartner title="Bairro">{address?.neighborhood}</ItemPartner>
        <ItemPartner title="Cidade">{address?.city}</ItemPartner>
        <ItemPartner title="Estado">{address?.state}</ItemPartner>
        <ItemPartner title="Complemento">{address?.complement}</ItemPartner>
        <ItemPartner title="E-mail">{email}</ItemPartner>
        <ItemPartner title="Site">{socialMedias?.website}</ItemPartner>
        <ItemPartner title="Instagram">{socialMedias?.instagram}</ItemPartner>
        <ItemPartner title="Facebook">{socialMedias?.facebook}</ItemPartner>

        <Grid item container md={6} xs={3} justifyContent="flex-end">
          <Button
            sx={{
              paddingX: 4,
              paddingY: 0,
              marginTop: 2,
              height: 36,
              alignSelf: 'flex-end',
            }}
            onClick={() => history.push(`${url[0]}edit/${id}`)}
          >
            editar
          </Button>
        </Grid>
      </Grid>
    </CustomAccordion>
  );
};
